import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { LoginProviderInterface } from "../types/provider.interface"

export class SocialLogin extends Component<{
    loginProviders: Array<LoginProviderInterface>
}> {
    private isAllProvidersHidden(): boolean {
        return this.props.loginProviders.every(
            (provider) => provider.isShow === false
        )
    }

    private hideSocialProviders(): void {
        this.props.loginProviders?.forEach((provider) => {
            const providerElement = document.getElementById(provider.elementId)

            if (providerElement && !provider.isShow) {
                providerElement.classList.add("hidden")
            }
        })
    }

    @handleComponentError("SocialLogin")
    render() {
        this.hideSocialProviders()
        this.show(!this.isAllProvidersHidden())

        super.render()
    }
}
